import { Component, signal } from '@angular/core';
import { Sidebar } from "../../shared/components/sidebar/sidebar";
import { Header } from "../../shared/components/header/header";
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-common-layout',
  imports: [Sidebar, Header, RouterOutlet],
  templateUrl: './common-layout.html',
  styleUrl: './common-layout.css',
})
export class CommonLayout {
  protected readonly isSidebarOpen = signal(false);
  protected readonly isSidebarCollapsed = signal(false);

  protected setSidebarOpen(isOpen: boolean): void {
    this.isSidebarOpen.set(isOpen);
  }

  protected toggleSidebar(): void {
    this.isSidebarOpen.set(!this.isSidebarOpen());
  }

  protected setSidebarCollapsed(isCollapsed: boolean): void {
    this.isSidebarCollapsed.set(isCollapsed);
  }
}
